import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import SoporteLayout from '../layouts/SoporteLayout';
import ReusableTable from '../components/ReusableTable';
import PrioridadButton from '../components/PrioridadButton';
import ComentarioButton from '../components/ComentarioButton';
import CambiarCategoriaButton from '../components/CambiarCategoriaButton';
import { formatearBogota } from '../utils/fecha';
import EvidenciaButton from '../components/EvidenciaButton';
import Modal from '../components/Modal';
import { getMisTareasResponsable } from '../services/tareasResponsableService';
import { getDetalleByParametroId } from '../services/Admin/detalleParametroService';
import { updateEstadoTarea } from '../services/tareasService';
import { jwtDecode } from 'jwt-decode';
import './HomePage.css';

// Función para verificar si el usuario es de soporte técnico
const esSoporteTecnico = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.rolId === '3';
  } catch (error) {
    console.error("Error decodificando el token:", error);
    return false;
  }
};

const TareasCompletarPage = () => {
  const navigate = useNavigate();
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mostrandoTareasCompletas, setMostrandoTareasCompletas] = useState(false);
  const [showEstadoModal, setShowEstadoModal] = useState(false);
  const [estadoLoading, setEstadoLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState('');
  const [tareaEstado, setTareaEstado] = useState(null);
  const [estadoError, setEstadoError] = useState('');
  const [showVerModal, setShowVerModal] = useState(false);
  const [detalleTarea, setDetalleTarea] = useState(null);

  useEffect(() => {
    const fetchTareas = async () => {
      const response = await getMisTareasResponsable(1); // Por defecto cargar tareas activas
      if (response.success) {
        console.log('Datos recibidos:', response.data);
        const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
        setTareas(tareasOrdenadas);
      } else {
        setError(response.message);
      }
      setLoading(false);
    };

    fetchTareas();
  }, []);

  const cargarTareasCompletas = async () => {
    setLoading(true);
    setError(null);
    const response = await getMisTareasResponsable(0);
    if (response.success) {
      console.log('Tareas completas recibidas:', response.data);
      const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
      setMostrandoTareasCompletas(true);
    } else {
      setError(response.message);
    }
    setLoading(false);
  };

  const cargarTareasActivas = async () => {
    setLoading(true);
    setError(null);
    const response = await getMisTareasResponsable(1);
    if (response.success) {
      console.log('Tareas activas recibidas:', response.data);
      const tareasOrdenadas = response.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
      setMostrandoTareasCompletas(false);
    } else {
      setError(response.message);
    }
    setLoading(false);
  };

  const handleAbrirEstadoModal = async (tarea) => {
    setTareaEstado(tarea);
    setSelectedEstado('');
    setEstadoError('');
    setShowEstadoModal(true);
    setEstadoLoading(true);
    try {
      const data = await getDetalleByParametroId(5);
      setEstados(data);
    } catch {
      setEstados([]);
    }
    setEstadoLoading(false);
  };

  const handleCerrarEstadoModal = () => {
    setShowEstadoModal(false);
    setTareaEstado(null);
    setSelectedEstado('');
    setEstadoError('');
  };

  const handleGuardarEstado = async (e) => {
    e.preventDefault();
    if (!selectedEstado) {
      setEstadoError('Seleccione un estado');
      return;
    }
    setEstadoLoading(true);
    const resp = await updateEstadoTarea(tareaEstado.idTarea, parseInt(selectedEstado));
    if (resp.success) {
      setTareas(prev => prev.map(t => t.idTarea === tareaEstado.idTarea ? { ...t, estadoId: parseInt(selectedEstado) } : t));
      handleCerrarEstadoModal();
    } else {
      setEstadoError(resp.message || 'Error al cambiar el estado');
    }
    setEstadoLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };

  const links = [
    { to: '/home', label: 'Home' },
    { to: '/crear-tarea', label: 'Crear Tarea' },
    { to: '/tareas', label: 'Ver Tarea' },
  ];

  // Si el usuario es de soporte técnico, añade el enlace de soporte
  if (esSoporteTecnico()) {
    links.push({ to: '/soporte', label: 'Soporte' });
  }

  const columns = [
    { key: 'idTarea', label: 'ID Tarea' },
    { key: 'observaciones', label: 'Observaciones' },
         { key: 'estado', label: 'Estado' },
    { key: 'prioridadNombre', label: 'Prioridad' },
    { 
      key: 'fechaCreacion',
      label: 'Fecha Creación',
      formatter: (date) => (date && date !== '0001-01-01T00:00:00' ? formatearBogota(date) : 'N/A')
    },
    { key: 'usuarioCreadorNombre', label: 'Usuario Creador' },
    { key: 'cargoUsuarioCliente', label: 'Cargo' },
    { key: 'areaNombre', label: 'Área' },
    { key: 'sedeNombre', label: 'Sede' },
    { key: 'servicioNombre', label: 'Servicio' },
    { key: 'categoriaNombre', label: 'Categoría' },
    { key: 'subcategoriaNombre', label: 'Subcategoría' },
    {
      key: 'rutaDocumento',
      label: 'Documento',
      formatter: (url) => url ? (<a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>Ver Documento</a>) : 'Sin documento'
    },
    { key: 'urlEvidencia', label: 'Evidencia', formatter: (url) => url ? (<a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>Ir a evidencia</a>) : '' },
         {
       key: 'acciones',
       label: 'Acciones',
       formatter: (value, row) => {
         if (!row) return null;
         return (
           <>
            <button
              className="view-btn"
              style={{ padding: '4px 12px', fontSize: '14px', marginRight: 6 }}
              onClick={() => { setDetalleTarea(row); setShowVerModal(true); }}
            >
              Ver
            </button>
             <ComentarioButton tareaId={row.idTarea} />
             <button
               className="cambiar-estado-btn"
               style={{ padding: '4px 12px', fontSize: '14px', marginLeft: 6 }}
               onClick={() => handleAbrirEstadoModal(row)}
             >
               Cambiar Estado
            </button>
            <PrioridadButton tareaId={row.idTarea} />
            <CambiarCategoriaButton tareaId={row.idTarea} areaId={row.areaId} />
            <EvidenciaButton tareaId={row.idTarea} />
           </>
         );
       }
     }
  ];



  const content = (
    <div>
      <h1>Mis Tareas Asignadas</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={cargarTareasActivas}
          disabled={loading}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: !mostrandoTareasCompletas ? '#007bff' : '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          Ver Tareas Activas
        </button>
                 <button
           onClick={cargarTareasCompletas}
           disabled={loading}
           style={{
             padding: '10px 20px',
             marginRight: '10px',
             backgroundColor: mostrandoTareasCompletas ? '#007bff' : '#6c757d',
             color: 'white',
             border: 'none',
             borderRadius: '5px',
             cursor: loading ? 'not-allowed' : 'pointer'
           }}
         >
           Ver Tareas Completadas
         </button>
      </div>

      {loading && <p>Cargando tareas...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && tareas.length > 0 && (
        <ReusableTable 
          data={tareas} 
          columns={columns}
          keyField="idTarea"
        />
      )}
      {!loading && !error && tareas.length === 0 && (
        <p>
          {mostrandoTareasCompletas 
            ? 'No hay tareas completadas disponibles' 
            : 'No hay tareas activas disponibles'
          }
        </p>
             )}
       
       {/* Modal de Cambio de Estado */}
      {showVerModal && (
        <Modal
          title={`Detalle de Tarea #${detalleTarea?.idTarea || ''}`}
          onClose={() => { setShowVerModal(false); setDetalleTarea(null); }}
          actions={
            <button 
              onClick={() => { setShowVerModal(false); setDetalleTarea(null); }}
              style={{
                padding: '8px 16px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Cerrar
            </button>
          }
        >
          {detalleTarea && (
            <div className="table-container">
              <table className="detail-table">
                <tbody>
                  <tr><th>Estado</th><td>{detalleTarea.estado}</td></tr>
                  <tr><th>Fecha Creación</th><td>{formatearBogota(detalleTarea.fechaCreacion)}</td></tr>
                  <tr><th>Fecha Edición</th><td>{detalleTarea.fechaEdicion ? formatearBogota(detalleTarea.fechaEdicion) : 'N/A'}</td></tr>
                  <tr><th>Área</th><td>{detalleTarea.areaNombre}</td></tr>
                  <tr><th>Sede</th><td>{detalleTarea.sedeNombre}</td></tr>
                  <tr><th>Servicio</th><td>{detalleTarea.servicioNombre}</td></tr>
                  <tr><th>Prioridad</th><td>{detalleTarea.prioridadNombre}</td></tr>
                  <tr><th>Categoría</th><td>{detalleTarea.categoriaNombre}</td></tr>
                  <tr><th>Subcategoría</th><td>{detalleTarea.subcategoriaNombre}</td></tr>
                  <tr><th>Observaciones</th><td>{detalleTarea.observaciones}</td></tr>
                  <tr><th>Usuario Creador</th><td>{detalleTarea.usuarioCreadorNombre}</td></tr>
                  <tr><th>Responsable</th><td>{detalleTarea.usuarioResponsableNombre || '(Sin responsable)'}</td></tr>
                  <tr><th>Cargo Usuario Cliente</th><td>{detalleTarea.cargoUsuarioCliente}</td></tr>
                  <tr><th>Calificación</th><td>{detalleTarea.calificacion ?? 'N/A'}</td></tr>
                  <tr><th>Comentario Calificación</th><td>{detalleTarea.comentarioCalificacion ?? 'N/A'}</td></tr>
                  <tr>
                    <th>Documento</th>
                    <td>{detalleTarea.rutaDocumento ? <a href={detalleTarea.rutaDocumento} target="_blank" rel="noopener noreferrer">Abrir</a> : 'Sin documento'}</td>
                  </tr>
                  <tr>
                    <th>Evidencia</th>
                    <td>{detalleTarea.urlEvidencia ? <a href={detalleTarea.urlEvidencia} target="_blank" rel="noopener noreferrer">Abrir</a> : 'Sin evidencia'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </Modal>
      )}
      {/* Modal de Cambio de Estado */}
       {showEstadoModal && (
         <Modal
           title="Cambiar Estado de la Tarea"
           onClose={handleCerrarEstadoModal}
           actions={
             <button
               onClick={handleCerrarEstadoModal}
               style={{
                 padding: '8px 16px',
                 backgroundColor: '#dc3545',
                 color: 'white',
                 border: 'none',
                 borderRadius: '4px',
                 cursor: 'pointer',
                 fontSize: '14px'
               }}
             >
               Cancelar
             </button>
           }
         >
           <form onSubmit={handleGuardarEstado}>
             <div style={{ marginBottom: '20px' }}>
               <h3>Tarea: {tareaEstado?.observaciones}</h3>
               <p><strong>ID:</strong> {tareaEstado?.idTarea}</p>
               <p><strong>Estado actual:</strong> {tareaEstado?.estadoId}</p>
             </div>
             {estadoError && <div style={{ color: 'red', marginBottom: '10px' }}>{estadoError}</div>}
             <div style={{ marginBottom: '15px' }}>
               <label htmlFor="estado" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                 Seleccionar nuevo estado:
               </label>
               <select
                 id="estado"
                 value={selectedEstado}
                 onChange={e => setSelectedEstado(e.target.value)}
                 style={{
                   width: '100%',
                   padding: '8px',
                   borderRadius: '4px',
                   border: '1px solid #ccc',
                   fontSize: '14px'
                 }}
                 disabled={estadoLoading}
               >
                 <option value="">Seleccione un estado</option>
                 {estados.map(opt => (
                   <option key={opt.id_detaparametro} value={opt.id_detaparametro}>{opt.nombre}</option>
                 ))}
               </select>
             </div>
             <div style={{ textAlign: 'right' }}>
               <button
                 type="submit"
                 className="cambiar-estado-btn"
                 disabled={estadoLoading}
                 style={{ fontSize: '14px' }}
               >
                 {estadoLoading ? 'Guardando...' : 'Guardar'}
               </button>
             </div>
           </form>
         </Modal>
       )}
     </div>
   );

  // Si el usuario es de soporte técnico, usar SoporteLayout
  if (esSoporteTecnico()) {
    return <SoporteLayout>{content}</SoporteLayout>;
  }

  // Si no es soporte técnico, usar el layout normal
  return (
    <div className="home-container">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="home-content">
        {content}
      </main>
    </div>
  );
};

export default TareasCompletarPage; 